import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Cookies from "js-cookie";


// import enTranslation  from './locales/en/translation.json';
import taTranslation from './locales/ta/translation.json'
import knTranslation from './locales/kn/translation.json'

const userLanguage = Cookies.get('userLanguage');

i18n
    .use(initReactI18next)
    .init({
        resources: {
            // en: { translation: enTranslation},
            ta: { translation: taTranslation},
            kn: { translation: knTranslation}

        },
    lng: userLanguage || 'en',//language from login
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    });
export default i18n;